interface EventType {
  NONE: string;
  SUCCESS: string;
  IN_PROGRESS: string;
  FAIL: string;
}

export const EventState: EventType = {
  NONE: "NONE",
  SUCCESS: "SUCCESS",
  IN_PROGRESS: "IN_PROGRESS",
  FAIL: "FAIL",
};

export enum MessageEventType {
  UpdateLastRead= 'updateLastRead',
  UpdatePageTitle= 'updatePageTitle'
}


export enum SocketTopics  {
  SurveyTopics= 'surveyTopics',
  SubscribePageTopics= 'subscribePageTopics',
  UnSubscribePageTopics= 'unSubscribePageTopics',
  PublishPageTopics= 'publishPageTopics',
}

export enum UserTopics {
  SearchInUser = 'searchInUser',
  User = 'user'
}

export enum PageTopics {
  SearchPageResult= 'searchPage/reply',
  CreatePageResult= 'createPage/reply',
  UpdatePageResult= 'updatePage/reply',
  SearchInPageResult= 'searchInPage/reply',
  PageTyping= 'pageTyping',
  GetProjectsResult= 'getProjects/reply',
  GetAdminRolesResult= 'getAdminRoles/reply',
  FocusPage= 'focusPage',
}

export enum TwilioTopics {
  VideoJoin = 'videoJoin',
  VideoEnd = 'videoEnd',
  SaveRecording= 'saveRecording',
  RecordingMediaResult= 'recordingMediaResult',
  GetTokenResult='getTokenResult'
}

export enum CLBSTopics {
  GetPlaces='get/places'
}

export enum MessageTopics {
  CreateMessageResult='group/members',
  SearchMessageResult='searchMessage/reply',
  ConnectionBDS='metadata/connections',
  FocusMessage='focusMessage'
}

export enum MapTopics {
  FocusMap = 'focusMap',
  IotAppend = 'iotAppend'
}

export enum UserSearchTopics {
  AggregateBds='aggregateBds/reply',
  FindUsersToPage='findUsersToPage/reply',
  SearchBds='searchBds/reply',
}

export enum IotTopics {
  Append='iot-service/append',
  GetLastIndex='getLastIndex/reply',
}